import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.abteilung-eingang2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsAbteilungEingang2Effects {

    AbteilungEingang2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ABTEILUNG_EINGANG2),
        mergeMap((x: ac.GetAbteilungEingang2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAbteilungEingang2(x.funktionsbereich_id, x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetAbteilungEingang2ErfolgreichAction(result, x.funktionsbereich_id, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAbteilungEingang2FehlerAction(error, x.funktionsbereich_id, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AbteilungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AbteilungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AbteilungQueryService);
        }
        return this.service;
    }
}
